import React, { useState } from 'react';
import { Button } from '../../../components/Button';
import ChatIcon from './supportChatIcon.svg';
import Styles from './SupportChatFacade.module.less';
import { loadWidget } from '../../../lib/chat/widget';

enum ChatState {
    Unloaded,
    Loading,
    Loaded,
}

export const SupportChatFacade = (): JSX.Element => {
    const [facadeState, setFacadeState] = useState<ChatState>(
        ChatState.Unloaded
    );

    const loadFacadeWidget = () => {
        setFacadeState(ChatState.Loading);
        loadWidget(null, true, 2);
    };

    return (
        <>
            <div className={Styles.chatContainer}>
                <Button
                    onClick={loadFacadeWidget}
                    shape="circle"
                    type="primary"
                    hidden={facadeState === ChatState.Loaded}
                    icon={
                        <img
                            width={24}
                            height={24}
                            alt="Converse com o suporte"
                            className={Styles.chatIcon}
                            src={ChatIcon}
                        />
                    }
                    loading={facadeState === ChatState.Loading}
                    className={Styles.chatButton}
                />
            </div>
        </>
    );
};
